import { InvoicePdfDto } from "api/dtos/InvoicePdfDto";
import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";

const fetchInvoicePdf = async (invoiceId) => {
  const res = await axiosInstance.get(`${URLS.invoices}/${invoiceId}/pdf/`, {
    responseType: "blob",
  });
  return InvoicePdfDto.fromApi(res);
};

const fetchLatestInvoice = async () => {
  const res = await axiosInstance.get(`${URLS.invoices}/`, {
    params: { payment_status: "paid" },
  });
  return res.data[0] ?? null;
};

const lookupTaxNumber = async (taxNumber, signal) => {
  const res = await axiosInstance.get(`${URLS.invoices}/lookup-tax-number/`, {
    params: { tax_number: taxNumber },
    signal,
  });
  return res.data;
};

export const invoicesApi = {
  fetchInvoicePdf,
  fetchLatestInvoice,
  lookupTaxNumber,
};
